import { ReactNode } from "react";
import { BANNER_TYPES } from "../Common/__styles__/Banner";
import { Header, Section } from "../Common/__styles__/FullPageFormLayout";
import Banner from "../Common/Banner";
import { Title } from "../Common/Typography";

export default ({
  header,
  warnings,
  children,
}: {
  header?: Maybe<string>;
  warnings: Array<string>;
  children?: ReactNode;
}) => (
  <>
    {header && (
      <Header>
        <Title size="default" type="semiBold">
          {header}
        </Title>
      </Header>
    )}
    <Section data-testid="property-warnings">
      {warnings.map(text => {
        const warning = text !== "None";
        return (
          <Banner
            key={text}
            type={warning ? BANNER_TYPES.ATTENTION : BANNER_TYPES.INFO}
          >
            {text}
          </Banner>
        );
      })}
      {children}
    </Section>
  </>
);
